export default "__VITE_ASSET__DBrrE7ZU__"